module.exports = __webpack_public_path__ + "img/文章资源.ce3fec25.jpg";